import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';

import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const InformationSubMenu = () => {
  const router = useRouter();
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-second-level-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-second-level-selected-menu';
    return '';
  }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component="nav"
      aria-label="Secondary Navigation"
    >
      <Container
        maxWidth="lg"
        sx={{
          p: '0 !important',
          display: 'flex',
          '& .Mui-second-level-selected-menu::before': { bottom: -10 },
        }}
      >
        <CustomButton
          href="/information-returns/"
          text="Information<br />Returns"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/information-icon.png"
              alt="Information Returns"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          // className={getActiveClassName(['/information-returns'])}
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          className={getSubMenuHoverClassName(
            'btn-information-supported-forms'
          )}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-information-supported-forms"
            onClick={() =>
              toggleSelectedSubMenu('btn-information-supported-forms')
            }
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/form-1099-series',
              '/aca-forms',
              '/wage-tax-forms',
            ])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { lg: 600, md: 590, sm: 540 },
              left: { md: '-90px !important', sm: '-90px !important' },
              '&:before': { left: { md: 156, sm: 140 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Box sx={{ p: 2, pt: 0, borderBottom: '1px Solid #ccc' }}>
                {/* <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}> */}
                <Typography
                  variant="h3"
                  sx={{ fontSize: '17px !important', fontWeight: 600, mb: 1 }}
                >
                  W-2 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 130 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w2/`}
                  >
                    Form W-2
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w2-c/`}
                  >
                    Form W-2c
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/`}
                  >
                    W-2 State Filing
                  </Button>{' '}
                </Stack>
              </Box>
              <Box
                component="div"
                sx={{ p: 2, borderBottom: '1px Solid #ccc' }}
              >
                {/* <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '17px !important',
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  {' '}
                  1099 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 140, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                      maxWidth: '100%',
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-series/`}
                  >
                    Form 1099
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-nec/`}
                  >
                    Form 1099-NEC
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-misc/`}
                  >
                    Form 1099-MISC
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-int/`}
                  >
                    Form 1099-INT
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 140, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-div/`}
                  >
                    Form 1099-DIV
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-a/`}
                  >
                    Form 1099-A
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-da/`}
                  >
                    Form 1099-DA
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-b/`}
                  >
                    Form 1099-B
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 140, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-k/`}
                  >
                    Form 1099-K
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-g/`}
                  >
                    Form 1099-G
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-r/`}
                  >
                    Form 1099-R
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-c/`}
                  >
                    Form 1099-C
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 140, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-s/`}
                  >
                    Form 1099-S
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-sa/`}
                  >
                    Form 1099-SA
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-ltc/`}
                  >
                    Form 1099-LTC
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-oid/`}
                  >
                    Form 1099-OID
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 140, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-patr/`}
                  >
                    Form 1099-PATR
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-q/`}
                  >
                    Form 1099-Q
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w-2g/`}
                  >
                    Form W-2G
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-3921/`}
                  >
                    Form 3921
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      display: 'flex !important',
                      justifyContent: 'left ',
                      borderRadius: 2,
                      width: { md: 140, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      mb: 0,
                      mt: 2,
                      maxWidth: 130,
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      textAlign: 'center',
                      m: 0,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-3922/`}
                  >
                    Form 3922
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      mb: 0,
                      mt: 2,
                      maxWidth: 130,
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      textAlign: 'center',
                      m: 0,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1097-btc/`}
                  >
                    Form 1097-BTC
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      mb: 0,
                      mt: 2,
                      maxWidth: 130,
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      textAlign: 'center',
                      m: 0,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1042-s/`}
                  >
                    Form 1042-S
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      mb: 0,
                      maxWidth: 200,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/`}
                  >
                    1099 State Filing
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 0,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      display: 'flex !important',
                      justifyContent: 'left ',
                      borderRadius: 2,
                      width: { md: 165, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      mb: 0,
                      maxWidth: 200,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-corrections/`}
                  >
                    Form 1099 Corrections
                  </Button>{' '}
                  {/* <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      mb: 0,
                      maxWidth: 200,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-da/`}
                  >
                    Form 1099-DA
                  </Button>{' '} */}
                </Stack>
              </Box>
              <Box
                component="div"
                sx={{ p: 2, pb: 2, borderBottom: '1px Solid #ccc' }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '17px !important', fontWeight: 600, mb: 1 }}
                >
                  5498 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 0,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 130 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498/`}
                  >
                    Form 5498
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498-esa/`}
                  >
                    Form 5498-ESA
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498-sa/`}
                  >
                    Form 5498-SA
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498-qa/`}
                  >
                    Form 5498-QA
                  </Button>{' '}
                </Stack>
                {/* </Paper> */}
              </Box>
              <Box
                component="div"
                sx={{ p: 2, pb: 2, borderBottom: '1px Solid #ccc' }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '17px !important', fontWeight: 600, mb: 1 }}
                >
                  1098 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 130 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098/`}
                  >
                    Form 1098
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-c/`}
                  >
                    Form 1098-C
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-e/`}
                  >
                    Form 1098-E
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-f/`}
                  >
                    Form 1098-F
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 130 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-t/`}
                  >
                    Form 1098-T
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-q/`}
                  >
                    Form 1098-Q
                  </Button>{' '}
                </Stack>
                {/* </Paper> */}
              </Box>
              <Box component="div" sx={{ p: 2, pb: 0 }}>
                <Typography
                  variant="h3"
                  sx={{ fontSize: '17px !important', fontWeight: 600, mb: 1 }}
                >
                  ACA Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 130 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}aca-forms/e-file-form-1095b/`}
                  >
                    Form 1095-B
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}aca-forms/e-file-form-1095c/`}
                  >
                    Form 1095-C
                  </Button>{' '}
                </Stack>
                {/* </Paper> */}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-information-w-2-states')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-information-w-2-states"
            onClick={() => toggleSelectedSubMenu('btn-information-w-2-states')}
            // href="/form-w2-state-filing/"
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName(['/form-w2-state-filing'])}
          >
            W-2 State Filing
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { md: 873, sm: 745 },
              left: 'auto !important',
              right: {
                lg: '-216px !important',
                md: '-300px !important',
                sm: '-329px !important',
              },
              '&:before': { right: { lg: 290, md: 266, sm: 400 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Link
                href="/form-w2-state-filing/"
                sx={{ pl: '16px !important', lineHeight: 'inherit !important' }}
              >
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={0}
                  sx={{
                    textAlign: 'left',
                    mt: -1.6,
                    '& :hover': {
                      color: '#4269e2 !important',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: '16px !important',
                      fontWeight: 600,
                      mb: 0,
                    }}
                  >
                    W-2 State Filing
                  </Typography>
                  <KeyboardDoubleArrowRightIcon />
                </Stack>
              </Link>
              <Grid
                container
                spacing={2}
                m={0}
                className="MuiGrid-root-width"
                sx={{
                  justifyContent: 'center',
                  px: 2,
                  mt: -2,
                  '& a': {
                    p: '10px !important',
                    borderColor: '#dedede',
                    borderRadius: 2,
                    // width: { md: 195 },
                    fontSize: {
                      sm: '11.5px !important',
                      md: '13px !important',
                    },
                  },
                  '& a:hover': {
                    color: '#4269e2 !important',
                    backgroundColor: '#dedfe1',
                    borderColor: '#637381',
                  },
                }}
              >
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/alabama-w-2-filing-requirements/`}
                    // className={getSubMenuActiveClassName(
                    //   '/form-w2-state-filing/alabama-w-2-filing-requirements'
                    // )}
                  >
                    Alabama (AL)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/arizona-w-2-filing-requirements/`}
                  >
                    Arizona (Az)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/arkansas-w-2-filing-requirements/`}
                  >
                    Arkansas (AR)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/colorado-w-2-filing-requirements/`}
                  >
                    Colorado (CO)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/connecticut-w-2-filing-requirements/`}
                  >
                    Connecticut (CT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/delaware-w-2-filing-requirements/`}
                  >
                    Delaware (DE)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/district-of-columbia-w-2-filing-requirements/`}
                  >
                    District of Columbia (DC)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/georgia-w-2-filing-requirements/`}
                  >
                    Georgia (GA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/hawaii-w-2-filing-requirements/`}
                  >
                    Hawaii (HI)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/idaho-w-2-filing-requirements/`}
                  >
                    Idaho (ID)
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/illinois-w-2-filing-requirements/`}
                  >
                    Illinois (IL)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/indiana-w-2-filing-requirements/`}
                  >
                    Indiana (IN)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/iowa-w-2-filing-requirements/`}
                  >
                    Iowa (IA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/kansas-w-2-filing-requirements/`}
                    // className={getSubMenuActiveClassName(
                    //   '/form-w2-state-filing/alabama-w-2-filing-requirements'
                    // )}
                  >
                    Kansas (KS){' '}
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/kentucky-w-2-filing-requirements/`}
                  >
                    Kentucky (KY)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/louisiana-w-2-filing-requirements/`}
                  >
                    Louisiana (LA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/maine-w-2-filing-requirements/`}
                  >
                    Maine (ME)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/maryland-w-2-filing-requirements/`}
                  >
                    Maryland (MD)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/massachusetts-w-2-filing-requirements/`}
                  >
                    Massachusetts (MA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/michigan-w-2-filing-requirements/`}
                  >
                    Michigan (MI)
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/minnesota-w-2-filing-requirements/`}
                  >
                    Minnesota (MN)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/mississippi-w-2-filing-requirements/`}
                  >
                    Mississippi (MS)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/missouri-w-2-filing-requirements/`}
                  >
                    Missouri (MO)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/montana-w-2-filing-requirements/`}
                  >
                    Montana (MT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/nebraska-w-2-filing-requirements/`}
                  >
                    Nebraska (NE)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/new-jersey-w-2-filing-requirements/`}
                  >
                    New Jersey (NJ)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/new-mexico-w-2-filing-requirements/`}
                  >
                    New Mexico (NM)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/north-carolina-w-2-filing-requirements/`}
                  >
                    North Carolina (NC)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/north-dakota-w-2-filing-requirements/`}
                  >
                    North Dakota (ND)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/ohio-w-2-filing-requirements/`}
                  >
                    Ohio (OH)
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/oklahoma-w-2-filing-requirements/`}
                  >
                    Oklahoma (OK)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/oregon-w-2-filing-requirements/`}
                  >
                    Oregon (OR)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/pennsylvania-w-2-filing-requirements/`}
                  >
                    Pennsylvania (PA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/rhode-island-w-2-filing-requirements/`}
                  >
                    Rhode Island (RI)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/south-carolina-w-2-filing-requirements/`}
                  >
                    South Carolina (SC)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/utah-w-2-filing-requirements/`}
                  >
                    Utah (UT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/vermont-w-2-filing-requirements/`}
                  >
                    Vermont (VT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/virginia-w-2-filing-requirements/`}
                  >
                    Virginia (VA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/west-virginia-w-2-filing-requirements/`}
                  >
                    West Virginia (WV)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/wisconsin-w-2-filing-requirements/`}
                  >
                    Wisconsin (WI)
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-information-1099-states')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-information-1099-states"
            onClick={() => toggleSelectedSubMenu('btn-information-1099-states')}
            // href="/form-w2-state-filing/"
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName(['/form-1099-state-filing'])}
          >
            1099 State Filing
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { md: 873, sm: 745 },
              left: 'auto !important',
              right: {
                lg: '-216px !important',
                md: '-191px !important',
                sm: '-180px !important',
              },
              '&:before': { right: { lg: 290, md: 266, sm: 245 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Link
                href="/form-1099-state-filing/"
                sx={{ pl: '16px !important', lineHeight: 'inherit !important' }}
              >
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={0}
                  sx={{
                    textAlign: 'left',
                    mt: -1.6,
                    '& :hover': {
                      color: '#4269e2 !important',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: '16px !important',
                      fontWeight: 600,
                      mb: 0,
                    }}
                  >
                    1099 State Filing
                  </Typography>
                  <KeyboardDoubleArrowRightIcon />
                </Stack>
              </Link>
              <Grid
                container
                spacing={2}
                m={0}
                className="MuiGrid-root-width"
                sx={{
                  justifyContent: 'center',
                  px: 2,
                  mt: -2,
                  '& a': {
                    p: '10px !important',
                    borderColor: '#dedede',
                    borderRadius: 2,
                    // width: { md: 195 },
                    fontSize: {
                      sm: '11.5px !important',
                      md: '13px !important',
                    },
                  },
                  '& a:hover': {
                    color: '#4269e2 !important',
                    backgroundColor: '#dedfe1',
                    borderColor: '#637381',
                  },
                }}
              >
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/alabama-filing-requirements/`}
                    // className={getSubMenuActiveClassName(
                    //   '/form-w2-state-filing/alabama-w-2-filing-requirements'
                    // )}
                  >
                    Alabama (AL)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/alaska-filing-requirements/`}
                  >
                    Alaska (AK)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/arizona-filing-requirements/`}
                  >
                    Arizona (AZ)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/arkansas-filing-requirements/`}
                  >
                    Arkansas (AR)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/california-filing-requirements/`}
                  >
                    California (CA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/colorado-filing-requirements/`}
                  >
                    Colorado (CO)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/connecticut-filing-requirements/`}
                  >
                    Connecticut (CT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/delaware-filing-requirements/`}
                  >
                    Delaware (DE)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/district-of-columbia-filing-requirements/`}
                  >
                    District of Columbia (DC)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/florida-filing-requirements/`}
                  >
                    Florida (FL)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/georgia-filing-requirements/`}
                  >
                    Georgia (GA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/hawaii-filing-requirements/`}
                  >
                    Hawaii (HI)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/idaho-filing-requirements/`}
                  >
                    Idaho (ID)
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/illinois-filing-requirements/`}
                  >
                    Illinois (IL)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/indiana-filing-requirements/`}
                  >
                    Indiana (IN)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/iowa-filing-requirements/`}
                  >
                    Iowa (IA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/kansas-filing-requirements/`}
                    // className={getSubMenuActiveClassName(
                    //   '/form-w2-state-filing/alabama-w-2-filing-requirements'
                    // )}
                  >
                    Kansas (KS){' '}
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/kentucky-filing-requirements/`}
                  >
                    Kentucky (KY)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/louisiana-filing-requirements/`}
                  >
                    Louisiana (LA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/maine-filing-requirements/`}
                  >
                    Maine (ME)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/maryland-filing-requirements/`}
                  >
                    Maryland (MD)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/massachusetts-filing-requirements/`}
                  >
                    Massachusetts (MA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/michigan-filing-requirements/`}
                  >
                    Michigan (MI)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/minnesota-filing-requirements/`}
                  >
                    Minnesota (MN)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/mississippi-filing-requirements/`}
                  >
                    Mississippi (MS)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/missouri-filing-requirements/`}
                  >
                    Missouri (MO)
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/montana-filing-requirements/`}
                  >
                    Montana (MT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/nebraska-filing-requirements/`}
                  >
                    Nebraska (NE)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/nevada-filing-requirements/`}
                  >
                    Nevada (NV)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/new-hampshire-filing-requirements/`}
                  >
                    New Hampshire (NH)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/new-jersey-filing-requirements/`}
                  >
                    New Jersey (NJ)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/new-mexico-filing-requirements/`}
                  >
                    New Mexico (NM)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/new-york-filing-requirements/`}
                  >
                    New York (NY)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/north-carolina-filing-requirements/`}
                  >
                    North Carolina (NC)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/north-dakota-filing-requirements/`}
                  >
                    North Dakota (ND)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/ohio-filing-requirements/`}
                  >
                    Ohio (OH)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/oklahoma-filing-requirements/`}
                  >
                    Oklahoma (OK)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/oregon-filing-requirements/`}
                  >
                    Oregon (OR)
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/pennsylvania-filing-requirements/`}
                    // className={getActiveClassName([
                    //   '/form-1099-state-filing/pennsylvania-filing-requirements',
                    // ])}
                  >
                    Pennsylvania (PA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/rhode-island-filing-requirements/`}
                  >
                    Rhode Island (RI)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/south-carolina-filing-requirements/`}
                  >
                    South Carolina (SC)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/south-dakota-filing-requirements/`}
                  >
                    South Dakota (SD)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/tennessee-filing-requirements/`}
                  >
                    Tennessee (TN)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/texas-filing-requirements/`}
                  >
                    Texas (TX)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/utah-filing-requirements/`}
                  >
                    Utah (UT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/vermont-filing-requirements/`}
                  >
                    Vermont (VT)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/virginia-filing-requirements/`}
                  >
                    Virginia (VA)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/west-virginia-filing-requirements/`}
                  >
                    West Virginia (WV)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/wisconsin-filing-requirements/`}
                  >
                    Wisconsin (WI)
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/wyoming-filing-requirements/`}
                  >
                    Wyoming (WY)
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>

        <Box
          className={getSubMenuHoverClassName('btn-information-instructions')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-information-instructions"
            onClick={() =>
              toggleSelectedSubMenu('btn-information-instructions')
            }
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/resources/information-returns/form-w-2-instructions',
              '/resources/information-returns/2024-form-w2-updates-filing-guide',
              '/resources/information-returns/form-w-2c-instructions',
              '/resources/information-returns/2025-form-w2-updates/',
              '/resources/information-returns/form-w2-mailing-address/',
              '/resources/information-returns/form-w2-vs-w4/',
              '/resources/information-returns/form-w2-vs-w9/',
              '/resources/information-returns/form-1099-nec-instructions',
              '/resources/information-returns/form-1099-misc-instructions',
              '/resources/information-returns/form-1099-int-instructions',
              '/resources/information-returns/form-1099-div-instructions',
              '/resources/information-returns/form-1099-b-instructions',
              '/resources/information-returns/form-1099-c-instructions',
              '/resources/information-returns/form-1099-k-instructions',
              '/resources/information-returns/form-1099-k-instructions',
              '/resources/information-returns/form-1099-r-instructions',
              '/resources/information-returns/form-1099-s-instructions',
              '/resources/information-returns/form-1099-q-instructions',
              '/resources/information-returns/form-1099-sa-instructions',
              '/resources/information-returns/form-1099-ltc-instructions',
              '/resources/information-returns/form-1099-oid-instructions',
              '/resources/information-returns/form-1099-patr-instructions',
              '/resources/information-returns/form-1099-da-instructions',
              '/resources/information-returns/form-1098-instructions',
              '/resources/information-returns/form-1098-e-instructions',
              '/resources/information-returns/form-5498-instructions',
              '/resources/information-returns/form-5498-esa-instructions',
              '/resources/information-returns/form-5498-sa-instructions',
            ])}
          >
            Instructions
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { lg: 600, md: 590, sm: 540 },
              left: { md: '-390px !important', sm: '-361px !important' },
              '&:before': { left: { md: 433, sm: 398 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Box sx={{ p: 2, pt: 0, borderBottom: '1px Solid #ccc' }}>
                {/* <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}> */}
                <Typography
                  variant="h3"
                  sx={{ fontSize: '16px !important', fontWeight: 600, mb: 1 }}
                >
                  W-2 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 180 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w-2-instructions/`}
                  >
                    Form W-2 Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/2024-form-w2-updates-filing-guide/`}
                  >
                    2024 Form W-2 Updates
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w-2c-instructions/`}
                  >
                    Form W-2c Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 180 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/2025-form-w2-updates/`}
                  >
                    2025 Form W-2 Updates
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w2-penalties/`}
                  >
                    W-2 Penalties for 2025
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w2-vs-w4/`}
                  >
                    Form W-2 vs Form W-4
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 180 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w2-vs-w9/`}
                  >
                    Form W-2 vs W-9
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w2-mailing-address/`}
                  >
                    W-2 Mailing Address
                  </Button>{' '}
                </Stack>
              </Box>
              <Box
                component="div"
                sx={{ p: 2, borderBottom: '1px Solid #ccc' }}
              >
                {/* <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '16px !important',
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  1099 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                      maxWidth: '100%',
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-nec-instructions/`}
                  >
                    1099-NEC Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-misc-instructions/`}
                  >
                    1099-MISC Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-int-instructions/`}
                  >
                    1099-INT Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-div-instructions/`}
                  >
                    1099-DIV Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-a-instructions/`}
                  >
                    1099-A Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-b-instructions/`}
                  >
                    1099-B Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-c-instructions/`}
                  >
                    1099-C Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-k-instructions/`}
                  >
                    1099-K Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-k-instructions/`}
                  >
                    1099-G Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-r-instructions/`}
                  >
                    1099-R Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-s-instructions/`}
                  >
                    1099-S Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-q-instructions/`}
                  >
                    1099-Q Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-sa-instructions/`}
                  >
                    1099-SA Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-ltc-instructions/`}
                  >
                    1099-LTC Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-oid-instructions/`}
                  >
                    1099-OID Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-patr-instructions/`}
                  >
                    1099-PATR Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1099-da-instructions/`}
                  >
                    1099-DA Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-5498-instructions/`}
                  >
                    5498 Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-5498-esa-instructions/`}
                  >
                    5498-ESA Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-5498-sa-instructions/`}
                  >
                    5498-SA Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-5498-qa-instructions/`}
                  >
                    5498-QA Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1097-btc-instructions/`}
                  >
                    1097-BTC Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1042-s-instructions/`}
                  >
                    1042-S Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-3921-instructions/`}
                  >
                    3921 Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 0,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      placeContent: 'center',
                      width: { md: 175, sm: '100%' },
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-3922-instructions/`}
                  >
                    3922 Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-w-2g-instructions/`}
                  >
                    W-2G Instructions
                  </Button>{' '}
                </Stack>
              </Box>
              <Box sx={{ p: 2, pt: 0, borderBottom: '1px Solid #ccc' }}>
                {/* <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '16px !important',
                    fontWeight: 600,
                    mt: 2,
                    mb: 1,
                  }}
                >
                  1098 Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-instructions/`}
                  >
                    1098 Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-c-instructions/`}
                  >
                    1098-C Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-e-instructions/`}
                  >
                    1098-E Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    mb: 1,
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-t-instructions/`}
                  >
                    1098-T Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-f-instructions/`}
                  >
                    1098-F Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-t-instructions/`}
                  >
                    1098-T Instructions
                  </Button>{' '}
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  {' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1098-q-instructions/`}
                  >
                    1098-Q Instructions
                  </Button>{' '}
                </Stack>
              </Box>
              <Box sx={{ px: 2, pt: 0 }}>
                {/* <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mb: 2 }}> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '16px !important',
                    fontWeight: 600,
                    mt: 2,
                    mb: 1,
                  }}
                >
                  ACA Forms
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    '& a': {
                      p: '10px !important',
                      borderColor: '#dedede',
                      borderRadius: 2,
                      width: { md: 175 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      placeContent: 'center',
                      fontSize: {
                        sm: '11.5px !important',
                        md: '13px !important',
                      },
                    },
                    '& a:hover': {
                      color: '#4269e2 !important',
                      backgroundColor: '#dedfe1',
                      borderColor: '#637381',
                    },
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1095-b-instructions/`}
                  >
                    1095-B Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-1095-c-instructions/`}
                  >
                    1095-C Instructions
                  </Button>{' '}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5, mb: 0 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/aca-forms-bulk-upload/`}
                  >
                    ACA Forms Bulk Upload
                  </Button>
                </Stack>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-information-due-dates')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-information-due-dates"
            onClick={() => toggleSelectedSubMenu('btn-information-due-dates')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Due Dates
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 220,
              m: 0,

              left: { sm: '-114px !important' },
              '&:before': { left: 150 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/information-returns/form-w-2-due-dates/">
                  Form W-2 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1099-due-dates/">
                  1099 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1098-series-due-dates/">
                  1098 Series Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1098-c-due-dates/">
                  Form 1098-C Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1098-f-due-dates/">
                  Form 1098-F Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1098-q-due-dates/">
                  Form 1098-Q Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/aca-form-due-date/">
                  ACA Form Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/aca-forms-penalties/">
                  ACA Forms Penalties
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1095-b-vs-1095-c/">
                  Form 1095-B and 1095-C
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-5498-due-dates/">
                  Form 5498 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-5498-esa-due-dates/">
                  Form 5498-ESA Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-5498-sa-due-dates/">
                  Form 5498-SA Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-3921-due-dates/">
                  Form 3921 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-3922-due-dates/">
                  Form 3922 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-1097-btc-due-dates/">
                  Form 1097-BTC Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/information-returns/form-w-2g-due-dates/">
                  Form W-2G Due Dates
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default InformationSubMenu;
